<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body
  >
    <el-form
      :model="form"
      :rules="rules"
      hide-required-asterisk
      ref="form"
      size="medium"
      label-position="left"
    >
      <el-form-item prop="subjectName">
        <template v-slot:label>
          <div class="form-item__label">主体名称</div>
        </template>
        <el-input
          v-model="form.subjectName"
          size="medium"
          placeholder="请输入主体名称"
        />
      </el-form-item>
      <!-- <el-form-item prop="subjectType"> -->
      <el-form-item label-width="90px">
        <template v-slot:label>
          <div>主体类型</div>
        </template>
        <el-radio v-model="form.subjectType" :label="1">结算主体</el-radio>
        <el-radio v-model="form.subjectType" :label="2">广告主主体</el-radio>
        <el-radio v-model="form.subjectType" :label="3">媒体主体</el-radio>
        <el-radio v-model="form.subjectType" :label="4">发票主体</el-radio>
      </el-form-item>
      <el-form-item label="签约主体" prop="subjectId">
        <el-select
          v-model="form.contractingPartyId"
          clearable
          filterable
          size="medium"
          placeholder="请选择主体名称"
          style="gaomargin-right: 15px; width: 100%"
        >
          <el-option
            v-for="item in statusList"
            :label="item.subjectName"
            :value="item.subjectId"
            :key="item.subjectId"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="unitAccountName">
        <template v-slot:label>
          <div class="form-item__label">公司开户行</div>
        </template>
        <el-input
          v-model="form.unitAccountName"
          size="medium"
          placeholder="公司开户行"
        />
      </el-form-item>
      <el-form-item prop="unitBankAccount">
        <template v-slot:label>
          <div class="form-item__label">公司银行账号</div>
        </template>
        <el-input
          v-model="form.unitBankAccount"
          size="medium"
          placeholder="公司银行账号"
        />
      </el-form-item>
      <el-form-item prop="unitName">
        <template v-slot:label>
          <div class="form-item__label">公司名称</div>
        </template>
        <el-input
          v-model="form.unitName"
          size="medium"
          placeholder="公司名称"
        />
      </el-form-item>
      <el-form-item prop="billingItems">
        <template v-slot:label>
          <div class="form-item__label">开票项目</div>
        </template>
        <el-input
          v-model="form.billingItems"
          size="medium"
          placeholder="开票项目"
        />
      </el-form-item>
      <el-form-item prop="identifier">
        <template v-slot:label>
          <div class="form-item__label">识别号</div>
        </template>
        <el-input
          v-model="form.identifier"
          size="medium"
          placeholder="识别号"
        />
      </el-form-item>
      <el-form-item prop="phoneNumber">
        <template v-slot:label>
          <div class="form-item__label">手机号</div>
        </template>
        <el-input
          v-model="form.phoneNumber"
          size="medium"
          placeholder="手机号"
        />
      </el-form-item>
      <el-form-item prop="recipient">
        <template v-slot:label>
          <div class="form-item__label">收件人</div>
        </template>
        <el-input v-model="form.recipient" size="medium" placeholder="收件人" />
      </el-form-item>
      <el-form-item prop="registeredAddressPhone">
        <template v-slot:label>
          <div class="form-item__label">注册地址及电话</div>
        </template>
        <el-input
          v-model="form.registeredAddressPhone"
          size="medium"
          placeholder="注册地址及电话"
        />
      </el-form-item>
      <el-form-item prop="shippingAddress">
        <template v-slot:label>
          <div class="form-item__label">收件地址</div>
        </template>
        <el-input
          v-model="form.shippingAddress"
          size="medium"
          placeholder="收件地址"
        />
      </el-form-item>
    </el-form>

    <div style="text-align: right">
      <el-button @click="close" size="medium">取消</el-button>
      <el-button
        @click="submit"
        type="primary"
        size="medium"
        :loading="submitLoading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>

import { getMasterSubjectInfo } from '@/api/report/dsp'
import { getSubjectInfo } from '@/api/manage/channel/channel'
import { addSubject, updateSubject } from '@/api/manage/subject/subject'

const form = {
}

export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    },
    data: Object
  },
  emits: ['submit'],
  components: {

  },
  data () {
    return {
      subjectList: [],
      statusList: [],
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, form),
      rules: {
        subjectName: [{ required: true, message: '请输入主体名称', trigger: 'change' }]
      },
      isAdd: true
    }
  },
  created () {
    this.getMasterSubjectInfo()
    this.getSubjectInfo()
  },
  computed: {
    dialogTitle () {
      return (this.title ? this.title : '') + (this.isAdd ? '新增' : '编辑')
    }
  },
  methods: {
    getSubjectInfo () {
      getSubjectInfo().then(res => {
        this.statusList = res.data
      })
    },
    getMasterSubjectInfo () {
      getMasterSubjectInfo().then(res => {
        this.subjectList = res.data
      })
    },
    show (row) {
      this.dialogStatus = true
      if (row) {
        this.form = Object.assign({}, row)
        this.isAdd = false
      }
    },
    close () {
      this.dialogStatus = false
      this.reset()
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.isAdd === false) {
            this.update(this.normalForm())
          } else {
            this.add(this.normalForm())
          }
        }
      })
    },
    normalForm () {
      return JSON.parse(JSON.stringify(this.form))
    },
    add (form) {
      this.submitLoading = true
      addSubject(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    update (form) {
      this.submitLoading = true
      updateSubject(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset () {
      this.form = Object.assign({}, form)
      this.$refs.form.resetFields()
    }
  }
}
</script>

  <style lang="scss" scoped>
.el-form-item {
  display: block;
}

.el-form-item ::v-deep .el-form-item__label {
  float: left;
}

.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}
</style>
